import { Fragment } from 'react';
import { Image, ImageProps } from 'tdesign-react';

import { RichMediaValue } from '@/interface/media';
import { getMediaUrlValue } from '@/material/form-upload/change-data';

/**
 * 图片组件
 * @param
 * @returns
 */
export const NovaImage: React.FC<
Omit<ImageProps, 'src'> & { src?: RichMediaValue }
> = (props) => {
  const url = getMediaUrlValue(props.src);
  return (
    <Fragment>
      <Image {...props} src={url} />
    </Fragment>
  );
};
